import useAuth from 'app/hooks/useAuth'
import axios from 'axios'
import _ from 'lodash'
import React, {
    createContext,
    useContext,
    useEffect,
    useRef,
    useState,
} from 'react'

const DashboardConfigContext = createContext(undefined)

export const useDashboardConfig = () => {
    const ctx = useContext(DashboardConfigContext)
    if (!ctx)
        throw Error('useDashboardConfig must use in DashboardConfigProvider')
    return ctx
}

const DashboardConfigProvider = ({ children }) => {
    const { selectedSystem } = useAuth()
    const [config, setConfig] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const [update, setUpdate] = useState(null)

    const fn = async (s) => {
        const res = await axios.get(
            `/api/analyzer/config/${
                s?.system_id || selectedSystem?.system_id || 'default'
            }`
        )
        setConfig(res.data?.data || null)
        setUpdate(res.data?.data || null)
    }
    useEffect(() => {
        fn(selectedSystem)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedSystem])

    const onSubmitUpdate = async () => {
        setIsLoading(true)
        try {
            console.log(update)
            await axios.put(
                `/api/analyzer/config/${selectedSystem.system_id}`,
                update
            )
        } catch (error) {
        } finally {
            setIsLoading(false)
            fn()
        }
    }

    const setUpdateConfig = (cb) => {
        setUpdate(cb(update))
    }

    return (
        <DashboardConfigContext.Provider
            value={{
                config,
                setUpdateConfig,
                onSubmitUpdate,
                isLoading,
                isChanged: !_.isEqual(config, update),
            }}
        >
            {children}
        </DashboardConfigContext.Provider>
    )
}

export default DashboardConfigProvider
